import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from 'components/main'

// Render the main component into the dom
const container = document.getElementById('app')
if (container != null) {
  const root = createRoot(container)
  // For the time being we can't take advantage of ReactDOM.hydrate(),
  // as the share buttons use the window.location, which produces wrong
  // attributes in react-snap – which are then not corrected by hydrate()
  root.render(<App />)
}
